<template>
  <div class="card u-w-100">
    <div class="u-w-100 u-text-align-center" v-html="image"></div>
    <div class="card__content">
      <p class="subtitle u-text-align-center" v-html="text"></p>
      <div class="u-w-100 u-text-align-center">
        <div class="btn btn--primary"
          @click="$emit('click')"
          :diabled="disabled == undefined ? false : disabled">
          {{label}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "StepOptions",
    props: ["img", "text", "label", "disabled"],
    data() {
      return {
        image: this.img
      };
    },
  }
</script>
